











































































import PreviewText from '@/helpers/PreviewText'
import { Prop, Component, Vue } from 'vue-property-decorator'
import ModalShowProfile from '@/components/Modal/ModalShowProfile.vue'
import { EUserStatus } from '@/models'
// @ts-ignore
import { Emoji } from 'emoji-mart-vue-fast'
import { getEmojiByNativeFunc, hanldeUserStatus } from '@/helpers/Common'

@Component({ components: { ModalShowProfile, Emoji } })
export default class ModalLikers extends Vue {
  @Prop({ default: 'display-liker' }) id!: string
  @Prop() listLiker!: ListLiker[]
  @Prop() emojiIndex: any
  @Prop({ type: Boolean, default: true }) showEmoji!: boolean
  @Prop({ type: Boolean, default: false }) loading!: boolean
  selectedLikerId: number = 1
  noAvatar = require('@/assets/images/avatar-default.png')
  eUserStatus = EUserStatus

  get shouldShowEmoji(): boolean {
    return this.showEmoji === true
  }

  /**
   * Show member profile modal
   */
  async showMemberProfile(liker: ListLiker) {
    if (
      liker.user_active_status !== EUserStatus.NORMAL ||
      liker.hide_administrator
    )
      return
    this.selectedLikerId = liker.id
    this.$bvModal.show('modal-liker-profile')
  }

  /**
   * Check user is same group tag
   */
  // async getUserProfileById() {
  //   return UserService.getUserProfileById(this.selectedLikerId)
  //     .then(res => {
  //       return res.status === 200 && res.data.is_same_group_tag
  //     })
  //     .catch(() => {
  //       return false
  //     })
  // }

  /**
   * Handle long text
   */
  handleLongText(liker: ListLiker) {
    if (liker?.hide_administrator) {
      return {
        name: this.$t('common.suffix.admin').toString(),
        text: this.$t('common.suffix.admin').toString()
      }
    }

    let text = hanldeUserStatus(liker.liker_name, liker.user_active_status)
    const preview = PreviewText.covertToPreviewText(text, 20)
    return {
      name: text,
      text: preview.text
    }
  }

  getEmojiByNative(nativeChar: string) {
    return getEmojiByNativeFunc(nativeChar, this.emojiIndex)
  }

  handleAvatar(liker: ListLiker) {
    if (liker?.hide_administrator) {
      return this.noAvatar
    }

    if (liker.avatar && liker.user_active_status !== EUserStatus.LEAVE_SYSTEM) {
      return liker.avatar
    }

    return this.noAvatar
  }
}

export interface ListLiker {
  id: number
  avatar: string
  liker_name: string
  user_active_status: EUserStatus
  emoji_id?: string
  hide_administrator?: boolean
}
